module.exports = "/_next/static/images/Channel-affacc60a6107d76cfbf7f8d1a688459.png";